<template>
    <single-select :value="selectedCountry" :options="countries" @input="onCountrySelected"
                   :getOptionLabel="localizeOption"/>
</template>
<script>
    import Vue from 'vue';
    import {Component, Model} from 'vue-property-decorator';
    import SingleSelect from '../../general/SingleSelect';
    import {COUNTRIES_GET} from '../../../store/modules/countries';

    @Component({
        components: {SingleSelect}
    })
    export default class CountryFilter extends Vue {
        @Model('input', {type: Number, default: null})
        input;

        get country_id() {
            return this.input;
        }

        set country_id(value) {
            this.$emit('input', value);
        }

        created() {
            this.$store.dispatch(COUNTRIES_GET);
        }

        get countries() {
            return [this.allCountry].concat(this.$store.state.countries.countries);
        }

        get loading() {
            return this.$store.state.countries.loading;
        }

        get error() {
            return this.$store.state.countries.errors.length > 0;
        }

        allCountry = {
            id: null,
            code: 'all',
            has_sales: true,
        };

        get selectedCountry() {
            if (this.loading || this.error || !this.country_id) {
                return this.allCountry;
            } else {
                return this.countries.find(country => country.id === this.country_id);
            }
        }

        localizeOption(country) {
            return this.$t('countries.' + country.code);
        }

        onCountrySelected(country) {
            this.country_id = country ? country.id : null;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/presetbar/CountryFilter.vue